import React from "react";
import RightArrowBullet from "@/Component/widgets/RightArrow";
import VideoPoster from "../../../../public/ai/video_cover_img.jpg";
import CustomVideo from "@/Component/VideoPlayer";

const ProbeMeAI = () => {
  return (
    <section className="page-left-sec_ why-choose-slm padding-left-x_ pb-x  overflow-hidden">
      <div className="container-fluid">
        <div className="row row-gap-4">
          <div className="col-sm-12 col-md-7 col-lg-8 col-xl-8 col-xxl-8 choose-blk">
            <div className="heading-sec res-head">
              <h2>ProbeMe AI</h2>
              <div className="sub-heading">
                Enhancing Meaningful Participant Communication
              </div>
              <div className="horizontal-row"></div>
            </div>
            <p>
              AI-led <b>ProbeMe</b> is an intelligent moderation platform that
              enables rich and engaging conversations with participants. Acting
              as an AI moderator, it actively listens, responds, and asks
              relevant follow-up questions based on participant input, ensuring
              insightful and dynamic interactions.{" "}
            </p>
            <div className="container-fluid">
              <div className="inc-hedding margin-ai-sec">
                <h5>Key Features & Functionalities:</h5>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Verbal Communication</h5>
                      <p>
                        Communicates with participants using natural, human-like
                        speech.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Smart Probing</h5>
                      <p>
                        Dynamically generates tailored follow-up questions based
                        on responses to uncover deeper insights.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Adaptive Interactions</h5>
                      <p>
                        Adjusts in real time to participant input, maintaining
                        relevance and engagement throughout the conversation.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Versatile Usage</h5>
                      <p>
                        Suitable for both online quantitative surveys and
                        qualitative in-depth interviews.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Multilingual Capability</h5>
                      <p>
                        Speaks and understands any language, with real-time
                        translation and transcription.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Scalability</h5>
                      <p>
                        Conducts multiple interviews simultaneously without
                        compromising quality.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Quick and Easy Set up</h5>
                      <p>
                        Very less time to initiate the qualitative research and
                        start fielding, subsequently free up the researcher’s
                        time to perform more complex task.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Integrated Text Analytics</h5>
                      <p>
                        Built-in analytics dashboard provides insights, key
                        theme extraction, and sentiment score directly from
                        conversation transcripts.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <div className="d-flex right-arrow-hover last-collumn-gap-mobile blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <h5>Quality Scoring</h5>
                      <p>
                        Evaluates both the quality of the conversation and the
                        depth of participant responses.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="inc-hedding margin-ai-sec">
                <h5>Business Use:</h5>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <p>
                        Qualitative studies including in-depth research :
                        ProbeMe works in both mode either stand-alone or
                        integrated with traditional research studies
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <p>
                        Feedback collection: Automated way to collect the
                        feedback data on product, services, or enhanced
                        offerings basis a brief questionnare done on mobile
                        devices
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <p>
                        Business research requiring in-depth AI probing with
                        tailored follow-up questions basis responses from
                        previous questions
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <div className="d-flex right-arrow-hover arrow-sec blk-sec-arrow">
                    <RightArrowBullet />
                    <div className="text-container heading-sec sec-paragraph">
                      <p>
                        Consumer Insights team seeking more granular verbatim
                        data with quick insights however don’t wish to deploy
                        traditional moderator for qual probing
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="
              col-sm-12 col-md-5 col-lg-4 col-xl-4 col-xxl-4 image-size">
            <div className="image-box ind-img-height img-blk-height">
              {/* <Image
                  src={Qprobe}
                  alt="Why Choose SLM"
                  className="img-boxshadow gray-scale"
                /> */}

              <CustomVideo
                poster={VideoPoster.src}
                urlsMp4={"/ai/final_video.mp4"}
                // urlsMp4={"https://ui.e2eresearch.com/website/final_video.mp4"}
                urlsWebm={"/ai/final_video.webm"}
              />
            </div>
          </div>
        </div>

        <div
          className="
              col-sm-12 col-md-5 col-lg-4 col-xl-4 col-xxl-4">
          <div className="inr-sec mt-3">
            {/* <p className="mb-0">
                <span
                  className="here-click hover-line-effect pointer-cursour"
                  onClick={handleModal}>
                  Contact With Us Today
                </span>
              </p> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProbeMeAI;
